module.exports = __webpack_public_path__ + "static/img/1.86539df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/eng/1.png
// module id = RdfY
// module chunks = 0